xtend = require 'xtend'

module.exports = (baseOptions) -> xtend baseOptions, locale: window.locale



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-options.coffee